import { AlertCircle, Loader2, Save, X } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { ShiftsFooterProps } from '@/types/ShiftForm'

/**
 * Footer for shift settings page
 * Controls the currently active (expanded) shift form
 */
const ShiftsFooter = ({ formControl }: ShiftsFooterProps) => {
  const isDisabled = !formControl?.isDirty || formControl?.isSaving

  return (
    <div className="bg-background fixed bottom-0 left-0 right-0 z-10 border-t">
      <div className="mx-auto max-w-7xl">
        <div className="flex h-20 w-full items-center justify-between gap-2 px-4 sm:gap-4 sm:px-6">
          {/* Status Indicator - Hidden on mobile, visible on tablet+ */}
          <div className="hidden items-center gap-2 text-sm md:flex">
            {formControl?.isDirty && !formControl?.isSaving && (
              <>
                <AlertCircle className="h-4 w-4 text-amber-500" />
                <span className="text-muted-foreground">Nicht gespeicherte Änderungen</span>
              </>
            )}
            {formControl?.isSaving && (
              <>
                <Loader2 className="text-primary h-4 w-4 animate-spin" />
                <span className="text-muted-foreground">Wird gespeichert...</span>
              </>
            )}
            {!formControl?.isDirty && !formControl?.isSaving && formControl && (
              <span className="text-muted-foreground">Alle Änderungen gespeichert</span>
            )}
            {!formControl && (
              <span className="text-muted-foreground">
                Öffnen Sie eine Schicht zum Bearbeiten
              </span>
            )}
          </div>

          {/* Mobile status indicator - Icon only */}
          <div className="flex items-center gap-2 md:hidden">
            {formControl?.isDirty && !formControl?.isSaving && (
              <AlertCircle className="h-4 w-4 text-amber-500" />
            )}
            {formControl?.isSaving && <Loader2 className="text-primary h-4 w-4 animate-spin" />}
          </div>

          {/* Action Buttons */}
          <div className="flex items-center gap-2 sm:gap-3">
            <Button
              variant="ghost"
              size="default"
              onClick={() => formControl?.onDiscard()}
              disabled={isDisabled}
              className="sm:min-w-[120px]"
            >
              <X className="h-4 w-4 sm:mr-2" />
              <span className="hidden sm:inline">Verwerfen</span>
            </Button>
            <Button
              size="default"
              onClick={() => formControl?.onSave()}
              disabled={isDisabled}
              className="sm:min-w-[120px]"
            >
              {formControl?.isSaving ? (
                <Loader2 className="h-4 w-4 animate-spin sm:mr-2" />
              ) : (
                <Save className="h-4 w-4 sm:mr-2" />
              )}
              <span className="hidden sm:inline">Speichern</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ShiftsFooter
